import IMHandler from './ImHandler';
import LogReport from '../log/LogReport'
import Constant from '../constant/Constant';
import account_dev from '../../../../js/account_dev';
import {language} from "@/language/get";

import { Notification, MessageBox } from 'element-ui';
function TICWebIM() {
    this.accountModel = null;
    this.classModel = null;
    this.imListener = null;
    this.boardNotifyCallback = null;
    this.imHandler = null;
    this.tim = TIM.create({
        SDKAppID: account_dev.sdkappid
    });
    // 注册 COS SDK 插件
    this.tim.registerPlugin({'cos-js-sdk': COS});
}

TICWebIM.prototype.setLog = function (log) {
    this.log = log;
}

TICWebIM.prototype.login = function (accountModel, classModel) {
    var me = this;
    this.initEvent();
    this.accountModel = accountModel;
    this.classModel = classModel;

    let promise = this.tim.login({
        userID: accountModel.userId,
        userSig: accountModel.userSig
    });
    promise.then((imResponse)=> {
        console.log(imResponse.data); // 登录成功
        if (imResponse.data.repeatLogin === true) {
            // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
            console.log(imResponse.data.errorInfo);
        }
        me.imHandler = new IMHandler(accountModel, classModel, me.tim);
    }).catch(function (imError) {
        console.warn('login error:', imError); // 登录失败的相关信息
    });
    return promise;

}

TICWebIM.prototype.logout = function () {
    return this.tim.logout();
}

TICWebIM.prototype.initEvent = function () {
    console.log('-WebIM----initEvent-------')
    var self = this;
    var tim = self.tim;
// 监听事件，如：
    tim.on(TIM.EVENT.SDK_READY, function (event) {
        console.log('-WebIM----SDK_READY-------')
        self.ready = true;
        self.statusListener.fireEvent('onImSDKReady')
        self.tim.updateMyProfile({
            nick: self.accountModel.userNick,
            role: self.accountModel.role
        }).then(function(imResponse) {
            console.log(imResponse.data); // 更新资料成功
        }).catch(function(imError) {
            console.warn('updateMyProfile error:', imError); // 更新资料失败的相关信息
        });
        // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
        // event.name - TIM.EVENT.SDK_READY
    });

    tim.on(TIM.EVENT.MESSAGE_RECEIVED, function (event) {
        console.log('-WebIM----MESSAGE_RECEIVED-------')
        // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
        // event.name - TIM.EVENT.MESSAGE_RECEIVED
        // event.data - 存储 Message 对象的数组 - [Message]
        console.log('received message----------->', event);
        self.messageHandler(event.data);
        for (var i = 0, item; item = event.data[i++];) {
            if (item.type == TIM.TYPES.MSG_TEXT) {
                console.log('text received',item, item.payload.text);
            }
        }
    });

    tim.on(TIM.EVENT.MESSAGE_REVOKED, function (event) {
        console.log('-WebIM----MESSAGE_REVOKED-------',event)
        // 收到消息被撤回的通知。使用前需要将SDK版本升级至v2.4.0或以上。
        // event.name - TIM.EVENT.MESSAGE_REVOKED
        // event.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isRevoked 属性值为 true
    });

    tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, function (event) {
        console.log('-WebIM----CONVERSATION_LIST_UPDATED-------',event)
        // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
        // event.name - TIM.EVENT.CONVERSATION_LIST_UPDATED
        // event.data - 存储 Conversation 对象的数组 - [Conversation]
    });

    tim.on(TIM.EVENT.GROUP_LIST_UPDATED, function (event) {
        console.log('-WebIM----GROUP_LIST_UPDATED-------',event)
        // 收到群组列表更新通知，可通过遍历 event.data 获取群组列表数据并渲染到页面
        // event.name - TIM.EVENT.GROUP_LIST_UPDATED
        // event.data - 存储 Group 对象的数组 - [Group]
    });

    tim.on(TIM.EVENT.PROFILE_UPDATED, function (event) {
        console.log('-WebIM----PROFILE_UPDATED-------',event)
        // 收到自己或好友的资料变更通知
        // event.name - TIM.EVENT.PROFILE_UPDATED
        // event.data - 存储 Profile 对象的数组 - [Profile]
    });

    tim.on(TIM.EVENT.BLACKLIST_UPDATED, function (event) {
        console.log('-WebIM----BLACKLIST_UPDATED-------',event)
        // 收到黑名单列表更新通知
        // event.name - TIM.EVENT.BLACKLIST_UPDATED
        // event.data - 存储 userID 的数组 - [userID]
    });

    tim.on(TIM.EVENT.ERROR, function (event) {
        console.log('-WebIM----ERROR-------',event)
        // 收到 SDK 发生错误通知，可以获取错误码和错误信息
        // event.name - TIM.EVENT.ERROR
        // event.data.code - 错误码
        // event.data.message - 错误信息
    });

    tim.on(TIM.EVENT.SDK_NOT_READY, function (event) {
        console.log('-WebIM----SDK_NOT_READY-------',event)
        self.ready = false;
        // 收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作
        // event.name - TIM.EVENT.SDK_NOT_READY
    });

    tim.on(TIM.EVENT.KICKED_OUT, function (event) {
        console.log('-WebIM----KICKED_OUT-------',event)
        // 收到被踢下线通知
        // event.name - TIM.EVENT.KICKED_OUT
        // event.data.type - 被踢下线的原因，例如 :
        //   - TIM.TYPES.KICKED_OUT_MULT_ACCOUNT 多实例登录被踢
        //   - TIM.TYPES.KICKED_OUT_MULT_DEVICE 多终端登录被踢
        //   - TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED 签名过期被踢（v2.4.0起支持）。
    });

    tim.on(TIM.EVENT.NET_STATE_CHANGE, function (event) {
        console.log("-----------网络状态发生改变----------------",event)
        if(event.data.state == 'disconnected'){
            console.log("-----------网络断开连接----------------")
            MessageBox({
              title: "",
              message: language().networkDisconnect,
              confirmButtonText: language().confirm,
              cancelButtonText: language().cancel,
              showCancelButton: false,
              showClose: false,
              // type: 'warning'
            }).then(() => {
              //确认
              window.history.go(-1)
            });
        }

        /**/
        Notification({
          title: "网络状态发生改变: "+event.data.state,
          duration: 5000,
          type: 'warning'
        });
        // 网络状态发生改变（v2.5.0 起支持）。
        // event.name - TIM.EVENT.NET_STATE_CHANGE
        // event.data.state 当前网络状态，枚举值及说明如下：
        //   - TIM.TYPES.NET_STATE_CONNECTED - 已接入网络
        //   - TIM.TYPES.NET_STATE_CONNECTING - 连接中。很可能遇到网络抖动，SDK 在重试。接入侧可根据此状态提示“当前网络不稳定”或“连接中”
        //   - TIM.TYPES.NET_STATE_DISCONNECTED - 未接入网络。接入侧可根据此状态提示“当前网络不可用”。SDK 仍会继续重试，若用户网络恢复，SDK 会自动同步消息
    });
}

TICWebIM.prototype.messageHandler = function (msgs) {
    let self = this;
    if (msgs.length) { // 如果有消息才处理
        msgs.forEach(msg => {
            var msgType = msg.conversationType;
            // 如果是群组消息
            if (msgType === TIM.TYPES.CONV_GROUP) {
                var groupid = msg.to;
                var contentType = msg.type;
                // if (groupid == self.accountModel.classId + '0000') {
                // 信令消息
                if (groupid == self.accountModel.classId + '') {
                    if (contentType == TIM.TYPES.MSG_CUSTOM) {
                        var extension = msg.payload.extension
                        if (extension == 'TXWhiteBoardExt') {
                            if (msg.from != self.accountModel.userId) {
                                self.boardNotifyCallback && self.boardNotifyCallback(msg);
                            }
                        } else if (extension == 'hySignalExt') {
                            self.resolveMessage(msg);
                        }
                    }
                    else {
                        self.resolveMessage(msg);
                    }
                }
                // 聊天消息
                else {
                    self.resolveMessage(msg);
                }
            } else if (msgType === TIM.TYPES.CONV_C2C) { // 如果是C2C消息
                self.resolveMessage(msg);
            } else if (msgType === TIM.TYPES.CONV_SYSTEM) {
                self.resolveMessage(msg);
            }
        });
    }
}


TICWebIM.prototype.resolveMessage = function (msg) {
    this.messageListener.fireEvent('onTICRecvMessage', msg);
    var convType = msg.conversationType;
    var to = msg.to;
    var messageType = msg.type;
    var payload = msg.payload;
    if (convType == TIM.TYPES.CONV_SYSTEM) {
        if (to == this.accountModel.classId) {
            if (messageType == TIM.TYPES.MSG_GRP_TIP) {
                var operationType = payload.operationType;
                if (operationType == TIM.TYPES.GRP_TIP_MBR_JOIN) {
                    console.log('-------有成员加群---------')
                    this.eventListener.fireEvent('onTICMemberJoin', payload.userIdList);
                } else if (operationType == TIM.TYPES.GRP_TIP_MBR_QUIT) {
                    console.log('-------有群成员退群---------')
                    this.eventListener.fireEvent('onTICMemberQuit', payload.userIdList);
                }
            }
        }
    }
    else if (convType == TIM.TYPES.CONV_GROUP) {
        if (to == this.accountModel.classId + 'im') {
            if (messageType == TIM.TYPES.MSG_TEXT) {
                this.messageListener.fireEvent('onTICRecvGroupTextMessage', msg);
            }
            if (messageType == TIM.TYPES.MSG_CUSTOM) {
                this.messageListener.fireEvent('onTICRecvGroupCustomMessage', msg);
            }
        }
        if (payload.extension == 'hySignalExt') {
            this.messageListener.fireEvent('onTICRecvSignalMessage',  msg);
        }
    }
    else if (convType == TIM.TYPES.CONV_C2C) {
        console.log('recieve c2c message', msg);
        //??  c2c 的消息 to会是classID?
        if (to == this.accountModel.classId + 'im') {
            if (messageType == TIM.TYPES.MSG_TEXT) {
                this.messageListener.fireEvent('onTICRecvTextMessage',  msg);
            }
            if (messageType == TIM.TYPES.MSG_CUSTOM) {
                this.messageListener.fireEvent('onTICRecvCustomMessage',  msg);
            }
        }

        if (to == this.accountModel.userId) {
            if (payload.extension == 'hySignalExt') {
                this.messageListener.fireEvent('onTICRecvSignalMessage',  msg);
            }
        }
    }
}

TICWebIM.prototype.getMessageList = function (groupid) {
    return this.tim.getMessageList({conversationID: 'GROUP' + groupid+'im', count: 15});
/*    promise.then(function(imResponse) {
        const messageList = imResponse.data.messageList; // 消息列表。
        const nextReqMessageID = imResponse.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段。
        const isCompleted = imResponse.data.isCompleted; // 表示是否已经拉完所有消息。
    });*/
}

/**
 * @classId 群组id
 * @scene 场景
 */
TICWebIM.prototype.createRoom = function (classId, scene) {
    classId = classId + '';
    scene = scene * 1;
    var me = this;
    // 聊天消息的群组 在classid后面加'im', classid的群组用于系统消息传递
    var options = {
        'groupID': classId + 'im',
        'type': TIM.TYPES.GRP_CHATROOM,
        'joinOption': TIM.TYPES.JOIN_OPTIONS_FREE_ACCESS,
        'name': classId,
        'notification': "",
        'introduction': "",
        'memberList': [],
    };

    function createWhiteboardGroup() {
        return me.tim.createGroup({
                // 'groupID': classId + '0000',
                'groupID': classId + '',
                'type': TIM.TYPES.GRP_CHATROOM,
                'joinOption': TIM.TYPES.JOIN_OPTIONS_FREE_ACCESS,
                'name': classId +'',
                //'name': classId +'0000',
                'notification': "",
                'introduction': "",
                'memberList': [],
       });
    }

    return new Promise((resolve, reject) => {
        this.tim.createGroup(options).then((imResponse) =>{ // 创建成功
            createWhiteboardGroup().then((wbResponse)=>{
                console.log('create whiteboard group succcess');
                resolve(imResponse); // 创建的群的资料
            }).catch((err)=> {
                console.warn('create whiteboard Group error:', err); // 创建群组失败的相关信息
                if (err.code == 10021) {
                    resolve();
                } else {
                    reject(err);
                }
            })
        }).catch((err) =>{
            console.warn('createGroup error:', err); // 创建群组失败的相关信息
            if (err.code == 10021) {
                createWhiteboardGroup().then((wbResponse)=>{
                    console.log('create whiteboard group succcess');
                    resolve();
                }).catch((err2)=> {
                    console.warn('create whiteboard Group error:', err); // 创建群组失败的相关信息
                    if (err2.code == 10021) {
                        resolve();
                    } else {
                        reject(err2);
                    }
                })
            } else if (err.code == 10021) {
                reject(err);
            } else {
                reject(err);
            }
        });
    });
}

/**
 * 加入白板信令群
 */
TICWebIM.prototype.joinRoom = function () {
    // 先创建群，成功后加入群
    return new Promise((resolve, reject) => {
        var groupID = String(this.accountModel.classId);

        this.tim.joinGroup({
            groupID: groupID  + 'im'
        }).then((imResponse) => {
            var status = imResponse.data.status;
            console.warn('joinGroup success:', imResponse); // 申请加群失败的相关信息
            if (status == TIM.TYPES.JOIN_STATUS_SUCCESS || status == TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP) {
                this.tim.joinGroup({
                    groupID: groupID + ''
                    // groupID: groupID + '0000'
                }).then((res)=>{
                    var status2 = res.data.status;
                    if (status2 == TIM.TYPES.JOIN_STATUS_SUCCESS || status2 == TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP) {
                        resolve(imResponse);
                    } else {
                        console.warn('join whiteboard group fail',res);
                        reject(res);
                    }
                }).catch(function (err) {
                        console.warn('join whiteboard Group error:', err); // 申请加群失败的相关信息
                        if (err.toString() == 'Error: 被邀请加入的用户已经是群成员。') { // 被邀请加入的用户已经是群成员,也表示成功
                            resolve(err);
                        } else {
                            reject(err);
                        }
                    });
            }
            else {
                reject(imResponse);
            }
        })
            .catch(function (err) {
                console.warn('joinGroup error:', err); // 申请加群失败的相关信息
                if (err.toString() == 'Error: 被邀请加入的用户已经是群成员。') { // 被邀请加入的用户已经是群成员,也表示成功
                    resolve(err);
                } else {
                    reject(err);
                }
            });
    });
}


/**
 * 销毁群组
 */
TICWebIM.prototype.destroyGroup = function (groupID) {
    return this.tim.dismissGroup(groupID);
}

/**
 * 退出群组
 */
TICWebIM.prototype.quitGroup = function () {
    var groupID = String(this.accountModel.classId);
    var signalGroup = groupID + '';
    // var signalGroup = groupID + '0000';

    function quitSignalGroup() {
        return new Promise((resolve, reject) => {
            this.tim.quitGroup(signalGroup).then(function (imResponse2) {
                resolve(imResponse2);
            }).catch((err)=>function () {
                // 群主想退群,则也认为成功
                if (err.ErrorCode == 10009) {
                    resolve();
                    return;
                }
                reject(err);
            });
        });
    }

    return new Promise((resolve, reject) => {
        this.tim.quitGroup(groupID + 'im')
            .then(function (imResponse) {
                quitSignalGroup().then(()=>{
                    resolve();
                }).catch((err)=>{
                    reject(err);
                })
            })
            .catch(function (err) {
                // 群主想退群,则也认为成功
                if (err.ErrorCode == 10009) {
                    quitSignalGroup().then(()=>{
                        resolve();
                    }).catch((err)=>{
                        reject(err);
                    })
                    return;
                }
                reject(err);
        });
    });
}


TICWebIM.prototype.setReceiveBoardNotifyCallback = function (callback) {
    this.boardNotifyCallback = callback;
}

/**
 * 发送C2C文本消息
 */
TICWebIM.prototype.sendC2CTextMessage = function (userId, msg, succ, fail) {
    this.imHandler.sendTextMessage(TIM.TYPES.CONV_C2C, msg, userId, succ, fail);
}

/**
 * 发送C2C自定义消息
 */
TICWebIM.prototype.sendC2CCustomMessage = function (userId, msg, succ, fail) {
    this.imHandler.sendCustomMsg(TIM.TYPES.CONV_C2C, msg, userId, succ, fail);
}

/**
 * 发送群文本消息
 */
TICWebIM.prototype.sendGroupTextMessage = function (msg, succ, fail) {
    var groupID = String(this.accountModel.classId) + 'im';
    this.imHandler.sendTextMessage(TIM.TYPES.CONV_GROUP, msg, groupID, succ, fail);
}

/**
 * 发送群组自定义消息
 */
TICWebIM.prototype.sendGroupCustomMessage = function (msg, succ, fail) {
    var groupID = String(this.accountModel.classId) + 'im';
    this.imHandler.sendCustomMsg(TIM.TYPES.CONV_GROUP, msg, groupID, succ, fail);
}

// 发送白板数据
TICWebIM.prototype.sendBoardGroupCustomMessage = function (msg) {
    this.imHandler.sendBoardGroupCustomMessage(JSON.stringify(msg));
}
TICWebIM.prototype.sendP2pSignal = function (to, content) {
    this.imHandler.sendP2pSignal(to, content);
}
TICWebIM.prototype.sendGroupSignal = function (content) {
    this.imHandler.sendGroupSignal(content);
}

TICWebIM.prototype.setMessageListener = function (messageListener) {
    this.messageListener = messageListener;
}

TICWebIM.prototype.setEventListener = function (eventListener) {
    this.eventListener = eventListener;
}

TICWebIM.prototype.setStatusListener = function (statusListener) {
    this.statusListener = statusListener;
}
TICWebIM.prototype.getProfile = function (userid) {
    return new Promise((resolve, reject)=> {
        let pro= this.tim.getUserProfile({
            userIDList: [userid]
        });
        pro.then(function(imResponse) {
            resolve(imResponse.data[0])
        }).catch(function(imError) {
            console.warn('getUserProfile error:', imError); // 获取其他用户资料失败的相关信息
            reject(imError)
        });
    })
}

export default TICWebIM;
